import { toast } from '@app/components/ui/Toast/toast'
import { queryClient } from '@app/config/queryClient'
import { deleteLayerSuitability } from '@app/domains/suitability/services/suitability.service'
import { useMutation } from '@tanstack/react-query'

export const useDeleteLayerSuitability = (layerId: string) => {
  return useMutation({
    mutationFn: ({ useCaseSlug }: { useCaseSlug: string }) =>
      deleteLayerSuitability(layerId, useCaseSlug),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['layer-suitability', layerId] })
    },
    onError: () => {
      toast({
        title: 'Failed to delete suitability',
        type: 'error',
        position: 'top-center',
      })
    },
  })
}
